<script>
  import { useLocation } from 'svelte-navigator'

  import Pill from '/Atoms/Pill'
  import Link from '/Atoms/Link'
  import Ksb from '/Atoms/Ksb'

  import { loading, footerHeight } from '/stores'
  import { onAlmanac } from '/routes'
  import { _ } from 'svelte-i18n'

  const location = useLocation();

  let almanac = false
  let pillColor = "white"


  $: console.log(footerHeight)

  $: {
    almanac = onAlmanac($location.pathname)
    pillColor = almanac ? "beige" : "white"
  }

</script>

<footer class:almanac class:hide={$loading && !almanac} bind:clientHeight={$footerHeight}>

  <ul class="comm">
    <li>
      <Link to={$_("footer.newsletter.url")} hover="none">
        <Pill color={pillColor} hover title={$_("footer.newsletter.title")}/>
      </Link>
    </li>
    <li>
      <Link to={$_("footer.telegram.url")} hover="none">
        <Pill color={pillColor} hover title={$_("footer.telegram.title")}/>
      </Link>
    </li>
    <li>
      <Link to="/contact" hover="none">
        <Pill color={pillColor} hover title={$_("footer.contact.title")}/>
      </Link>
    </li>
    <li>
      <Link to="/press" hover="none">
        <Pill color={pillColor} hover title={$_("footer.press.title")}/>
      </Link>
    </li>
    <li>
      <Link to={$_("footer.onlineshop.url")} hover="none">
        <Pill color={pillColor} hover title={$_("footer.onlineshop.title")}/>
      </Link>
      </li>
  </ul>

  <ul class="legal">
    <li>
      <Link to="/data-privacy" hover="none">
        <Pill color={pillColor} hover title={$_("footer.privacy.title")}/>
      </Link>
    </li>
    <li>
      <Link to="/imprint" hover="none">
        <Pill color={pillColor} hover title={$_("footer.imprint.title")}/>
      </Link>
    </li>
  </ul>
  
  <p class="text">

    {@html $_("footer.text.part1")}
    <Link hover="white-underline" href={$_("footer.text.ksb_link_url")}>{@html $_("footer.text.ksb_link_text")}</Link>
    {@html $_("footer.text.part2")} <br />
    <Link hover="white-underline" to="/supporters"><pre>{$_("footer.text.supporters")}</pre></Link>
    
  </p>

  <figure class="ksb">
    <Ksb black={almanac}/>
  </figure>

</footer>

<style lang="scss">

  pre {
    display: inline;
  }
  footer {
    @include media-large-only {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: auto auto;
      grid-gap: 15px;
    }
    padding-top: 30px;
    padding-bottom: 20px;

    @include grid-margin;
    @include typo-grotesk-text-18;

    &.hide {
      visibility: hidden;
    }
  }

  .comm, .legal {
    li {
      @include media-large-only {
        float: left;
      }
      padding-right: 10px;
      padding-bottom: 15px;
    }
  }

  @include media-small {
    .comm, .legal {
      margin-bottom: 15px;
    }
    .text {
      margin-bottom: 30px;
      max-width: 500px;
    }
  }

  .comm {
    grid-column: 1;
    grid-row: 1;
  }

  .legal {
    grid-column: 2;
    grid-row: 1;
  }

  .text {
    grid-column: 1;
    grid-row: 2;
    color: $color-white;
    .almanac & {
      color: black;
    }
  }

  .ksb {
    grid-column: 2;
    grid-row: 2;
    justify-self: end;
    align-self: end;
  }
</style>
